<template>
  <div class="validation-error" v-if="validation_field.$error">
    <template v-for="validation in validation_field.$params">
      <span
        v-if="validation && validation.type && !validation_field[validation.type]"
        v-bind:key="validation.type"
        class="helper-text data-error"
        data-error="wrong"
        :data-validation="debug(validation)"
        >{{
          validation.custom_message?validation.custom_message:($i18n.te(`${lang_prefix}.${name}.${validation.type}`)?$t(`${lang_prefix}.${name}.${validation.type}`, validation):$t(`${lang_prefix}.${validation.type}`, validation))
        }}</span
      >
    </template>
  </div>
</template>

<script>
export default {
  props: {
    validation_field: {
      type: Object,
      default: () => { return {} },
    },
    name: {
        type: String,
        required: true
    },
    lang_prefix: {
        type: String,
        required: true
    }
  },
  methods: {
    debug(v) {
      return JSON.stringify(v, null, 2)
    }
  }
};
</script>

<style>
.validation-error .helper-text {
  color: #F44336;
  float: left;
  font-size: 0.8rem;
  margin-top: 5px;
}
.validation-error--marginNone .helper-text {
  margin: 0px;
}
</style>